export default "__VITE_ASSET__f8aba8fd__"